import * as appHelper from './appHelper';
import * as dataHelper from './dataHelper';
import _ from 'lodash';


export function getPreviousIndicatorResultForObject(biteIndicatorHistory, screen_id, asset_id) {
    let result = {};
    for (let i = 0; i < biteIndicatorHistory.length; i++) {
        let history = biteIndicatorHistory[i];
        if (history.screen_id === screen_id && history.asset_id === asset_id) {
            result = Object.assign({}, history);
        }
    }
    return result;
}


export function getPreviousIndicatorResultResultIndex(biteIndicatorHistory, screen_id, asset_id, kpi_id) {
    let currentAttempt = -1;
    let result = -1;
    for (let i = 0; i < biteIndicatorHistory.length; i++) {
        let history = biteIndicatorHistory[i];
        if (history.screen_id === screen_id && history.asset_id === asset_id) {
            result = i;
            currentAttempt = history.attempt;
        }
    }
    return result;
}

export function getIndicatorOutcome(indicator,currentIndicatorValue){
    let returnOutcome = {};
    for (let i = 0; i < indicator.outcomes.length; i++) {
        let outcome = indicator.outcomes[i];
        if(outcome.must_be_less_than_to_value){
            if(currentIndicatorValue >= outcome.from && currentIndicatorValue < outcome.to){
                returnOutcome = Object.assign({},outcome);
                break;
            }
        }else{
            if(currentIndicatorValue >= outcome.from && currentIndicatorValue <= outcome.to){
                returnOutcome = Object.assign({},outcome);
                break;
            }else if(currentIndicatorValue > outcome.to){
                returnOutcome = Object.assign({},outcome);
                break;
            }
        }

    }
    //console.log(`getIndicatorOutcome`,returnOutcome);

    return returnOutcome;
}

export function getCheckedOptionIndicators(checkedOptions){
    let indicators = [];
    _.forEach(checkedOptions, function (option) {
        if(appHelper.isDefined(option.indicators)) {
            _.forEach(option.indicators, function (indicator) {
                let indicatorIndex = appHelper.getArrayObjectIndexByKey(indicators, "indicator_id", indicator.indicator_id);

                if (indicatorIndex === -1) {
                    indicators = dataHelper.immutablePush(indicators, indicator);
                } else {

                    let existingIndicator =  Object.assign({},indicators[indicatorIndex],
                        {
                            value: parseInt(indicators[indicatorIndex].value) + parseInt(indicator.value),
                        });

                    indicators = dataHelper.immutableSplice(indicators, indicatorIndex, 1, existingIndicator);
                }
            });
        }
    });

    return indicators;
}


/** WEBPACK FOOTER **
 ** ./src/helpers/indicatorHelper.js
 **/